import { DatabaseIcon } from "@/shared/constants/icon";
import { ProductsCardType } from "./types";
import { IconEdit } from "@/public/assets/icons/IconEdit";
import { IconHeadPhones } from "@/public/assets/icons/IconHeadPhones/IconHeadPhones";

export const OUR_PRODUCTS_DATA: ProductsCardType[] = [
  {
    id: 1,
    icon: <DatabaseIcon color="var(--color-cream)" size={'1.5dvw'} />,
    url: '/textremover',
    storeUrl: 'https://chromewebstore.google.com/detail/mdgaedbildmelnjjmpcmnjkhmgeicdlo',
    img: ['/assets/images/TextRemoverImage.svg', '/assets/images/textRemoverImage2.svg', '/assets/images/textRemoverImage3.svg'],
    tKey: 'textRemover'
  },
  {
    id: 2,
    icon: <IconEdit fill="var(--color-cream)" width={'1.5dvw'} height={'1.5dvw'} />,
    url: '/drawingonline',
    storeUrl: 'https://chromewebstore.google.com/detail/pdokhmldlccplfhhekeconkblhkmiold',
    img: ['/assets/images/drawingImage2.svg', '/assets/images/drawingImage2.svg', '/assets/images/drawingImage3.svg'],
    tKey: 'drawingOnline'
  },
  {
    id: 3,
    icon: <h3 style={{ fontSize: '1.5dvw', color: "var(--color-cream)" }}>AI</h3>,
    url: '/ai-agent',
    storeUrl: '',
    img: ['/assets/images/aIImage.svg'],
    tKey: 'aiAgent'
  },
  {
    id: 4,
    icon: <IconHeadPhones fill="var(--color-black)" stroke="var(--color-cream)" width={'2dvw'} height={'2dvw'} />,
    url: '/music_player',
    storeUrl: '',
    img: ['/assets/images/MusicPlayerImage1.png', '/assets/images/MusicPlayerImage2.png', '/assets/images/MusicPlayerImage3.png', '/assets/images/MusicPlayerImage4.png'],
    tKey: 'musicPlayer'
  },
]; 
